import { Alert, Box, Card, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { base_logo_url, base_url } from '../../apis/constants';
import { useLocation } from 'react-router-dom';
export default function NoModuleAssigned(props) {
  const [invalidModuleDialog, setInvalidModuleDialog] = useState(true);

  console.log(props, 'CurrentRoute');
  const location = useLocation();
  // const invalidUrl = location.state?.invalidUrl || 'Unknown URL';
  const handleClose = () => {
    setInvalidModuleDialog(false);
  };
  const [invalidUrl, setInvalidUrl] = useState('');

  useEffect(() => {
    const url = localStorage.getItem('invalidUrl') || 'Unknown URL';
    setInvalidUrl(url);
    // Optionally clear the invalid URL after displaying it
    localStorage.removeItem('invalidUrl');
  }, []);
  return (
    <Container component='main' maxWidth='md' sx={styles.container}>
      <Box sx={styles.box}>
        <Typography variant='h2' align='center' sx={styles.heading}>
          Module Not Assigned!
        </Typography>
        <Typography variant='h6' align='center' sx={styles.subHeading}>
          "{invalidUrl}" module is not assigned by admin!
        </Typography>
        <Box sx={styles.linkBox}>
          <Alert sx={{ mt: 2 }} severity='info'>
            Click on Sidebar Assigned Modules or Contact Admin.
          </Alert>
        </Box>
      </Box>
    </Container>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh',
    backgroundColor: '#f5f5f5'
  },
  box: {
    textAlign: 'center',
    padding: 4,
    backgroundColor: 'white',
    borderRadius: 2,
    boxShadow: 3
  },
  heading: {
    // fontWeight: 'bold',
    fontSize: '38',
    color: '#1976d2'
  },
  subHeading: {
    marginBottom: 0,
    marginTop: 4,
    color: '#666',
    fontSize: '16'
  },
  linkBox: {
    marginTop: 3
  },
  button: {
    backgroundColor: '#1976d2',
    '&:hover': {
      backgroundColor: '#1565c0'
    }
  }
};
